
import { Vue, Component } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import TextInputButton from '@/components/shared/TextInputButton.vue';

const namespace: string = 'cart';

@Component<CartDiscount>({
	components: {
		TextInputButton
	}
})

export default class CartDiscount extends Vue {
	@Action('validateDiscountCodeAndGetValue', { namespace }) private validateDiscountCodeAndGetValue!: (object: any) => void;
	@Action('removeDiscount', { namespace }) private removeDiscountAction!: () => void;
	@Getter('getPromoDiscountInfo', { namespace }) private promoDiscountInfo!: any;

	private discountCode: string = '';
	private discountMessage: string = '';
	private validatingCode: boolean = false;

	/**
	 * Get discount code if it was applied before
	 *
	 * @return {void}
	 */
	private created(): void {
		if (this.promoDiscountInfo?.code) {
			this.discountCode = this.promoDiscountInfo.code;
			this.discountMessage = this.$t('checkout.cart.discount.code_applied');
		}
	}

	/**
	 * Validate and apply discount to the subtotal
	 *
	 * @return {void}
	 */
	private async applyDiscount(): Promise<void> {
		if (!this.discountCode.trim()) {
			return;
		}

		this.discountMessage = '';

		try {
			this.validatingCode = true;
			await this.validateDiscountCodeAndGetValue(this.discountCode);
			this.discountMessage = this.$t('checkout.cart.discount.code_applied');
		}
		catch {
			this.discountMessage = this.$t('checkout.cart.discount.code_failed');
		}
		finally {
			this.validatingCode = false;
			this.discountCode = this.promoDiscountInfo.code;
		}
	}

	/**
	 * Remove applied discount
	 *
	 * @return {void}
	 */
	private removeDiscount(): void {
		this.removeDiscountAction();
		this.discountCode = '';
		this.discountMessage = '';
	}
}
